module.exports = __webpack_public_path__ + "b57dd8a09faaa4d1c1bdf61287f1c0a0.jpg";